import {
  AUTHENTICATION_FAILURE,
  AUTHENTICATION_REQUEST,
  AUTHENTICATION_SUCCESS,
  CLIENT_CREATED,
  LOGOUT,
  SIGNUP_ERROR,
  UPDATE_PROFILE_SUCCESS
} from '../constants'

const initialState = {
  currentUser: {},
  isAuthenticated: false,
  willAuthenticate: true,
  signupErrors: {},
  currentClient: {}
}

export default function(state = initialState, action) {
  switch (action.type) {
    case LOGOUT:
      return {
        ...state,
        willAuthenticate: false
      }
    case AUTHENTICATION_REQUEST:
      return {
        ...state,
        willAuthenticate: true
      }
    case AUTHENTICATION_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        willAuthenticate: false,
        currentUser: action.user
      }
    case AUTHENTICATION_FAILURE:
      return {
        ...state,
        isAuthenticated: false,
        willAuthenticate: false
      }
    case SIGNUP_ERROR:
      return {
        ...state,
        signupErrors: action.errors
      }
    case UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        currentUser: action.user
      }
    case CLIENT_CREATED:
      return {
        ...state,
        currentClient: action.client
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/session.js